// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import Updates from "src/components/pages/Updates/Updates"

const UpdatesFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, "updatesPage.sections", [])
  const posts = _.get(data, "posts.nodes", [])
  const tweets = _.get(data, "tweets.nodes", [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.updatesPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Updates sections={sections} posts={posts} tweets={tweets} />
    </Layout>
  )
}

export default UpdatesFr

export const query = graphql`
  query UpdatesFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    updatesPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    posts: allStrapiPost(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...post
      }
    }

    tweets: allStrapiTweet(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...tweet
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
